import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * FilterSet item interface for ui_metadata storage
 */
export interface FilterSetItem {
  id: string;
  displayLabel: string;
  label: string;
  name?: string;
  scope?: 'COMPANY' | 'PERSONAL';
  type?: string;
}

/**
 * Transform API response to FilterSetItem format
 */
export const transformFilterSet = (apiItem: {
  id: string | number;
  label?: string;
  name?: string;
  scope?: 'COMPANY' | 'PERSONAL';
  type?: string;
}): FilterSetItem => ({
  id: String(apiItem.id),
  displayLabel: apiItem.label || apiItem.name || String(apiItem.id),
  label: apiItem.label || apiItem.name || String(apiItem.id),
  name: apiItem.name,
  scope: apiItem.scope,
  type: apiItem.type,
});

/**
 * Modal configuration for FilterSet selector
 */
export const filterSetModalConfig: GenericSelectorModalConfig<FilterSetItem> = {
  title: 'Select Filter Set',
  searchPlaceholder: 'Search filter sets...',
  emptyStateIcon: faFilter,
  emptyStateMessage: 'No filter set selected',
  noResultsMessage: (searchTerm) => `No filter sets found for "${searchTerm}"`,
  colorTheme: 'indigo',
  selectionMode: 'single',
  showConnectorToggle: false,
  defaultConnector: 'ALL',
  getItemLabel: (item) => item.label,
  getItemKey: (item) => item.id,
  isItemSelected: (item, selectedItems) =>
    selectedItems.some((s) => s.id === item.id),
  itemLabel: 'filter set',
  itemLabelPlural: 'filter sets',
};

/**
 * Node display configuration for FilterSet
 */
export const filterSetNodeConfig: GenericNodeComponentConfig<FilterSetItem> = {
  colorTheme: 'indigo',
  getItemLabel: (item) => item.label,
  getItemKey: (item) => item.id,
  maxVisibleItems: 1, // Single selection
  showConnectorLabel: false,
};
